export enum LocalesTypeEnum {
  ROUND = 'ROUND',
  UPSELL = 'UPSELL',
  LEADERBOARD = 'LEADERBOARD',
  CHALLENGE = 'CHALLENGE',
  GLOBAL_STREAK_ROUND = 'STREAK',
  TEAM = 'TEAM',
  MARKET = 'MARKET'
}
